import React, { useEffect, useState } from "react";
import { FileClock } from "lucide-react";
import { Skeleton } from "@/components/ui/skeleton";
import { Badge } from "@/components/ui/badge";
import adminApi from "@/lib/admin-api";

export default function AdminActivityPage() {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    adminApi.get("/activity").then(({ data }) => setLogs(data)).finally(() => setLoading(false));
  }, []);

  return (
    <div className="space-y-6">
      <div>
        <h1 className="font-serif text-3xl font-bold">Activity log</h1>
        <p className="text-muted-foreground text-sm mt-0.5">Audit trail of every admin action.</p>
      </div>

      {loading ? (
        <div className="space-y-2">
          {Array.from({ length: 6 }).map((_, i) => <Skeleton key={i} className="h-14 rounded-xl" />)}
        </div>
      ) : logs.length === 0 ? (
        <div className="bg-card border rounded-2xl p-12 text-center text-muted-foreground">
          <FileClock className="w-12 h-12 mx-auto opacity-20 mb-3" />
          <p className="font-medium">No activity yet</p>
        </div>
      ) : (
        <div className="bg-card border rounded-2xl divide-y">
          {logs.map((l) => (
            <div key={l.id} className="p-4 flex items-start gap-4" data-testid={`admin-activity-${l.id}`}>
              <div className="w-9 h-9 rounded-lg bg-primary/10 text-primary flex items-center justify-center shrink-0">
                <FileClock className="w-4 h-4" />
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <p className="font-semibold text-sm">{l.admin_name}</p>
                  <Badge className="text-[10px] bg-muted text-muted-foreground border">{l.action}</Badge>
                  {l.target_type && (
                    <span className="text-[10px] text-muted-foreground">on {l.target_type}</span>
                  )}
                </div>
                {l.details && (
                  <p className="text-xs text-muted-foreground mt-1 font-mono break-all">
                    {Object.entries(l.details).map(([k, v]) => `${k}=${typeof v === "object" ? JSON.stringify(v) : v}`).join(" • ")}
                  </p>
                )}
                <p className="text-[11px] text-muted-foreground mt-1">
                  {new Date(l.created_at).toLocaleString("en-GB")}
                </p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
